import { userDataAtom } from "Recoil/atoms"
import { useRecoilState } from "recoil"

import { Footer } from "Layouts/Footer/Footer"
import AdBanner from "Components/AdBanner"

import FeaturedCourses from "./FeaturedCourses"
import PlansSection from "./PlansSection"
import UserCourses from "./UserCourses"
import ChosenForYou from "./ChosenForYou"
import AllCourses from "./AllCourses"
import AdBannerMain from "Components/AdBannerMain"
// import BabyYoda from "yoda/BabyYoda"

export const HomePage = () => {
   const [userData] = useRecoilState(userDataAtom)

   // const [isLargerThan768] = useMediaQuery(['(min-width: 768px)'])

   // const navigate = useNavigate()

   // const [linkHasCopied, setLinkHasCopied] = useState(false)
   // useEffect(() => {
   //    let timer: NodeJS.Timeout
   //    if (linkHasCopied) {
   //       timer = setTimeout(() => {
   //          setLinkHasCopied(false)
   //          navigate("/offerta")
   //       }, 1000)
   //    }
   //    return () => clearTimeout(timer)
   // }, [linkHasCopied])

   return (
      <>
         <div className='w-[96%] min-h-[80vh] flex flex-col gap-0 sm:container mx-auto pb-8 pt-[25px] md:pt-[50px]'>
            {/* <BabyYoda /> */}

            <AdBannerMain />

            <div className='mt-5'>
               <AdBanner top={true} />
            </div>

            <FeaturedCourses />

            {userData?.accessToken && (
               <>
                  <UserCourses />
               </>
            )}

            <AdBanner top={false} />

            {userData?.accessToken && (
               <>
                  <ChosenForYou />
               </>
            )}
            {userData?.accessToken && <AdBanner top={false} />}

            <AllCourses />

            <PlansSection />
         </div>

         <Footer />
      </>
   )
}
